import React from 'react';
import fr from 'facet-rest';
import PropTypes from 'prop-types';
import {
  InstitutionGroup,
} from 'Views/Onboarding/Pages/Survey/SurveyStep/StepLibrary/OnboardingAssetsAndLiabilitiesAdd/OnboardingAssetsAndLiabilitiesAddContent/InstitutionGroup';
import { FDStack } from '@facet-wealth/design';
import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import Text from 'Components/ComponentLibrary/Atoms/Text';
import { MetaResourceRenderer } from 'Components/UI/Meta/MetaForm/Components/MetaResourceRenderer';
import { noop } from 'lodash';

const metaOverrideSet = buildFacetDesignOverride()
  .nameOverride(['institutionName', 'institutionTotalBalance'], {
    _component: () => Text,
    _customProps: {
      weight: 'extraBold',
      variant: 'h2',
      color: 'primary',
      align: 'center',
    },
  }, overrideReadOnly);

const InstitutionGroups = ({ groupCollection, onRefresh }) => {
  return (
    <FDStack direction={'column'} spacing={5}>
      {groupCollection.resources().list().map((group) => (<MetaResourceRenderer
        key={group.id()}
        resource={group}
        layout={InstitutionGroup}
        LayoutProps={{
          onRefresh,
        }}
        metaOverrideSet={metaOverrideSet}
      />))}
    </FDStack>
  );
};

InstitutionGroups.defaultProps = {
  onRefresh: noop,
};

InstitutionGroups.propTypes = {
  groupCollection: PropTypes.instanceOf(fr.Collection).isRequired,
  onRefresh: PropTypes.func,
};

export { InstitutionGroups };
